import { Content, Editor } from '@tiptap/react'
import { useEffect, useRef } from 'react'

/**
 * Custom hook for TextEditor that permits the initial value to
 * be set once, if it was initially undefined.
 */
export const useInitialValue = (
  editor: Editor | null,
  initialValue?: Content
) => {
  const hasInitialText = useRef<boolean>(initialValue !== undefined)

  // If initialValue is updated after init, update it *once*
  useEffect(() => {
    if (
      editor &&
      !editor.isDestroyed &&
      initialValue &&
      !hasInitialText.current
    ) {
      editor.commands.setContent(initialValue)
      // Prevent effect from updating content again
      hasInitialText.current = true
    }
  }, [editor, initialValue])
}
